import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/images/logo.png";
import Transition from "../utils/Transition";

import { getAuth } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import profileImg from "../assets/images/COOK-E.png";
// import homeImageBackground from "../assets/images/homeBackground.png";
import homeImageBackground from "../assets/images/user-avatar.png";
import { switchLoginStatus } from "../redux/auth";
import { clearTokens } from "../redux/tokens";
import { playAudio } from "../utils/btnAudio";

import { useDarkMode } from "../DarkModeProvider";
import { CButton } from "./CommonComponents";

function Header({ profilePhoto }) {
  const auth = getAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const profileMenuButtonRef = useRef();
  const trigger = useRef(null);
  const mobileNav = useRef(null);
  const { pathname: currentPath } = location;
  const currentUser = auth.currentUser;

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { shouldShowNavigationWarning } = useSelector((state) => state.uiSlice);
  const abc = useSelector((state) => state);

  console.log(shouldShowNavigationWarning, "shouldShowNavigationWarning", abc);

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [photoURL, setPhotoURL] = useState("");
  const { isDarkMode, setIsDarkMode } = useDarkMode();

  useEffect(() => {
    if (profilePhoto) {
      setPhotoURL(profilePhoto);
    } else {
      const photoURL = localStorage.getItem("photoURL");

      if (
        photoURL !== null &&
        photoURL !== undefined &&
        photoURL !== "" &&
        photoURL !== "undefined"
      ) {
        setPhotoURL(photoURL);
      } else {
        setPhotoURL(profileImg);
      }
    }
  }, [profilePhoto]);

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  useEffect(() => {
    const clickOutsideHandler = ({ target }) => {
      if (
        isProfileMenuOpen &&
        profileMenuButtonRef.current &&
        !profileMenuButtonRef.current.contains(target)
      ) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("click", clickOutsideHandler);
    return () => document.removeEventListener("click", clickOutsideHandler);
  }, [isProfileMenuOpen]);

  const dispatch = useDispatch();
  const logout = () => {
    playAudio();
    // await signOut(auth);
    dispatch(clearTokens());
    dispatch(switchLoginStatus(false));
    localStorage.removeItem("uid");

    setTimeout(() => {
      window.location.reload();
      // navigate("/");
    }, 1000);
  };

  // close the mobile menu on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!mobileNav.current || !trigger.current) return;
      if (
        !mobileNavOpen ||
        mobileNav.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setMobileNavOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close the mobile menu if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!mobileNavOpen || keyCode !== 27) return;
      setMobileNavOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  // Handle light modes
  const [darkMode, setDarkMode] = useState(() => {
    const dark = localStorage.getItem("darkMode");
    if (dark === null) {
      return true;
    } else {
      return dark === "true";
    }
  });

  const navArr = [
    { name: "Food Ideas", slug: "/discover-dishes" },
    { name: "Cookbook", slug: "/personal-cookbook" },
    { name: "Shop", slug: "/shop" },
    { name: "Merch", slug: "/merch-store" },
    { name: "Blog", slug: "/blogs" },
    { name: "Help", slug: "/help" },
  ];

  const menuDropDownNav = [
    { name: "Contact Us", slug: "/feedback" },
    { name: "Settings", slug: "/settings" },
  ];

  const onNavItemClick = (slug) => {
    if (currentPath == "/get-dishes") {
      Swal.fire({
        title: "Leave Page?",
        text: "You might lose your token if you leave this page",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Leave",
        denyButtonText: `Stay`,
        showCloseButton: true,
        showCancelButton: false,
        dangerMode: true,
        allowOutsideClick: false,
        allowEnterKey: false,
        showCloseButton: false,
      }).then(async (result) => {
        if (result.isDenied) {
          // return;
        } else {
          navigate(slug);
        }
      });
    } else if (
      currentPath == "/dishe-details" ||
      currentPath == "/get-recipe"
    ) {
      if (shouldShowNavigationWarning) {
        Swal.fire({
          title: "Leave Page?",
          text: "You might lose your token if you leave this page",
          icon: "warning",
          showDenyButton: true,
          confirmButtonText: "Leave",
          denyButtonText: `Stay`,
          showCloseButton: true,
          showCancelButton: false,
          dangerMode: true,
          allowOutsideClick: false,
          showCloseButton: false,
        }).then(async (result) => {
          if (result.isDenied) {
            // return;
          } else {
            navigate(slug);
          }
        });
      } else {
        navigate(slug);
      }
    } else {
      //if shop-merch, open in new tab
      if (slug == "/shop-merch") {
        window.open("https://cook-e-store.printify.me/", "_blank");
      } else {
        navigate(slug);
      }
    }
  };

  const showTopTickerWarning = () => {
    if (currentPath == "/dishe-details" || currentPath == "get-recipe")
      return true;
    else return false;
  };

  return (
    <>
      <header className="w-[100%] z-30">
        {showTopTickerWarning() && (
          <p className="text-center text-black text-[8px] font-bold p-1 shadow-gray-700 bg-yellow-500  mx-auto">
            You might lose your token if you leave this page without saving the
            recipe
          </p>
        )}
        <div className=" bg-white dark:bg-black rounded-full lg:max-w-[80%] max-w-[95%] mx-auto">
          <div className="w-full mx-auto px-2 sm:px-6">
            <div className="flex items-center justify-between py-[10px]">
              <nav className="flex md:grow justify-between w-full">
                <div className="flex items-center gap-6">
                  <div className="shrink-0 ">
                    {/* Logo */}
                    <Link to="/" className="block" aria-label="Cruip">
                      <div className="relative">
                        <div className="flex space-x-3">
                          <img
                            src={logo}
                            alt="logo"
                            className="w-[40px] h-[40px]"
                          />
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="hidden md:flex">
                  <ul className="flex grow flex-wrap items-center font-medium justify-center gap-4">
                    {navArr.map((item, index) => {
                      return (
                        <li
                          key={index}
                          onClick={() => onNavItemClick(item?.slug)}
                        >
                          <span
                            className={`py-2 flex  items-center transition duration-150 ease-in-out cursor-pointer hover:text-primary-600 ${
                              currentPath == item.slug
                                ? " text-orange-200 font-bold"
                                : "text-black  font-medium dark:text-white dark:hover:text-primary-600"
                            }`}
                            // style={{
                            //   color:
                            // }}
                          >
                            {item.name}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="hidden md:flex shrink-0 items-center">
                  {isLoggedIn ? (
                    <div className="relative mt-1">
                      <div>
                        <button
                          ref={profileMenuButtonRef}
                          onMouseEnter={toggleProfileMenu}
                          type="button"
                          className="relative flex rounded-full !bg-gray-800 text-sm focus:outline-none !focus:ring-2 focus:ring-white !focus:ring-offset-2 !focus:ring-offset-gray-800"
                          id="user-menu-button"
                          aria-expanded="false"
                          aria-haspopup="true"
                        >
                          <span className="absolute -inset-1.5"></span>
                          <img
                            className="h-8 w-8 rounded-full object-contain"
                            src={profileImg}
                            alt=""
                          />
                        </button>
                      </div>

                      {/* Profile dropdown */}
                      {isProfileMenuOpen && (
                        <div
                          className="absolute right-0 z-[9999] mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="user-menu-button"
                          tabindex="-1"
                        >
                          <button
                            href="/profile"
                            className="block px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabindex="-1"
                            id="user-menu-item-0"
                            onClick={() => {
                              playAudio();
                              onNavItemClick(`/profile/${currentUser?.uid}`);
                            }}
                          >
                            Your Profile
                          </button>

                          <button
                            href="/feedback"
                            className="block px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabindex="-1"
                            id="user-menu-item-1"
                            onClick={() => {
                              playAudio();
                              onNavItemClick("/feedback");
                            }}
                          >
                            Contact Us
                          </button>
                          <button
                            href="/settings"
                            className="block px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabindex="-1"
                            id="user-menu-item-1"
                            onClick={() => {
                              playAudio();
                              onNavItemClick("/settings");
                            }}
                          >
                            Settings
                          </button>
                          <hr />
                          <button
                            onClick={() => setIsDarkMode(!isDarkMode)}
                            className="block px-4 py-2 text-sm text-gray-700"
                          >
                            {isDarkMode
                              ? "Switch to Light Mode"
                              : "Switch to Dark Mode"}
                          </button>
                          <hr />
                          {/* <span className="text-tiny font-bold">
                            {isDarkMode ? "Dark Mode" : "Light Mode"} is Enabled
                          </span> */}

                          <button
                            className="block px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabindex="-1"
                            id="user-menu-item-2"
                            onClick={logout}
                          >
                            Sign out
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link to="/signin" className="">
                      <CButton label={"Log in"} variant={"orange"} />
                      {/* Login */}
                    </Link>
                  )}
                </div>
              </nav>

              {/* Mobile menu */}
              <div className="inline-flex md:hidden ">
                {/* Hamburger button */}
                <button
                  ref={trigger}
                  className={`hamburger ${mobileNavOpen && "active"}`}
                  aria-controls="mobile-nav"
                  aria-expanded={mobileNavOpen}
                  onClick={() => {
                    playAudio();
                    setMobileNavOpen(!mobileNavOpen);
                  }}
                >
                  <span className="sr-only">Menu</span>
                  <svg
                    className="w-6 h-6 fill-current text-primary-600 hover:animate-pulse dark:text-gray-300 dark:hover:text-gray-100 transition duration-150 ease-in-out"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect y="4" width="24" height="2" rx="1" />
                    <rect y="11" width="24" height="2" rx="1" />
                    <rect y="18" width="24" height="2" rx="1" />
                  </svg>
                </button>

                {/*Mobile navigation */}
                <Transition
                  show={mobileNavOpen}
                  tag="ul"
                  className="fixed top-0 h-screen z-20 left-0 w-full  -ml-16 overflow-scroll   shadow-lg"
                  enter="transition ease-out duration-200 transform"
                  enterStart="opacity-0 -translate-x-full"
                  enterEnd="opacity-100 translate-x-0"
                  leave="transition ease-out duration-200"
                  leaveStart="opacity-100"
                  leaveEnd="opacity-0"
                >
                  <nav
                    id="mobile-nav"
                    ref={mobileNav}
                    className="fixed top-0 h-screen z-0 left-0 w-full opacity-100  -ml-16 bg-black shadow-lg no-scrollbar"
                  >
                    {/* Background image */}
                    <div className="absolute inset-0 h-auto box-content -z-1">
                      <img
                        className="absolute inset-0 opacity-20 w-full h-full object-cover "
                        src={homeImageBackground}
                        width="1440"
                        height="577"
                        alt="About"
                      />
                      {/* <div className="absolute inset-0 bg-gradient-to-t from-white dark:from-gray-900" aria-hidden="true"></div> */}
                    </div>
                    <div className="py-6  pl-[64px]">
                      {/* Logo */}
                      <Link
                        to="/"
                        className="flex justify-center py-6 my-4"
                        aria-label="Cruip"
                      >
                        <img src={logo} alt="logo" className="w-12 h-12" />
                      </Link>
                      {/* Links */}
                      {[...navArr, ...menuDropDownNav].map((item, index) => (
                        <li key={index}>
                          <Link
                            to={item.slug}
                            className=" w-full flex   bg-white shadow-xl  bg-clip-padding bg-opacity-25  justify-center text-center text-white
                       dark:text-gray-300 dark:hover:text-gray-100 py-3 
                       
                       "
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}

                      <li onClick={logout}>
                        <Link
                          className=" w-full flex   bg-white shadow-xl  bg-clip-padding bg-opacity-25  justify-center text-center text-white
                       dark:text-gray-300 dark:hover:text-gray-100 py-3 
                       
                       "
                        >
                          Logout
                        </Link>
                      </li>
                      {/* <ul className="space-y-4">
                    <li>
                      <Link
                        to="/discover-dishes"
                        className=" w-full flex   bg-white shadow-xl  bg-clip-padding bg-opacity-25  justify-center text-center text-white
                       dark:text-gray-300 dark:hover:text-gray-100 py-3 
                       
                       "
                      >
                        Food Ideas
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/shop"
                        className=" w-full flex bg-white shadow-xl  bg-clip-padding bg-opacity-25  justify-center text-center text-white
                       dark:text-gray-300 dark:hover:text-gray-100 py-3
                       
                       "
                      >
                        Shop
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/chopping-block"
                        className=" w-full flex bg-white shadow-xl  bg-clip-padding bg-opacity-25  justify-center text-center text-white
                       dark:text-gray-300 dark:hover:text-gray-100 py-3
                       
                       "
                      >
                        Chopping Block
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/personal-cookbook"
                        className=" w-full flex bg-white shadow-xl  bg-clip-padding bg-opacity-25  justify-center text-center text-white
                       dark:text-gray-300 dark:hover:text-gray-100 py-3
                       
                       "
                      >
                        CookBook
                      </Link>
                    </li>
                    {/* <li className="py-2 my-2 border-t border-b border-gray-200 dark:border-gray-800">
                      <span className="flex text-gray-600 dark:text-gray-400 py-2">Resources</span>
                      <ul className="pl-4">
                        <li>
                          <Link
                            to="/help"
                            className="text-sm flex font-medium text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 py-2"
                          >
                            Help center
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/404"
                            className="text-sm flex font-medium text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 py-2"
                          >
                            404
                          </Link>
                        </li>
                      </ul>
                    </li> 
                    {isLoggedIn ? (
                      <li>
                        <Link
                          to="/"
                          onClick={logout}
                          className="font-medium w-3/5 mx-[20%] flex items-center justify-center border border-transparent px-4 py-2 my-2 rounded text-white bg-teal-500 hover:bg-teal-400 transition duration-150 ease-in-out"
                        >
                          Logout
                        </Link>
                      </li>
                    ) : (
                      <li>
                        <Link
                          to="/signin"
                          className="font-medium w-3/5 mx-[20%] flex items-center justify-center border border-transparent px-4 py-2 my-2 rounded text-white bg-teal-500 hover:bg-teal-400 transition duration-150 ease-in-out"
                        >
                          Login
                        </Link>
                      </li>
                    )}
                  </ul> */}
                    </div>
                  </nav>
                </Transition>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
